const initialValues = {
  name: '',
  range_start: '',
  range_end: '',
  is_anomaly: '0',
  order: '',
  color_code: '#3D5AFE',
};
export default initialValues;
